let timer = null; // 定时器

function getScrollTop () {
    return document.documentElement.scrollTop || document.body.scrollTop;
}

function isScrollEnd(t1) {
    const t2 = getScrollTop();
    return t2 === t1
}

function combination(success) {
    clearTimeout(timer);
    const t1 = getScrollTop();
    timer = setTimeout(() => {
        if(isScrollEnd(t1)) {
            if(success()) combination(success)
        }
    }, 500);
}

export default {
    watch(success = function() {}) {
        combination(success)
        // scroll监听
        window.addEventListener('scroll', () => {
            combination(success)
        })
    }
}